module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('h2', {
    staticClass: "chapterNumber"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/plainclothesnaked_con#ch_02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TWO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("Detective Manny Rubert hated the idea of policemen almost as much as he hated himself for being one. He always figured there were people who chose their fate, and people who had a fate they’d more or less ended up with. He thought of himself as the “ending up” type.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Scant as it was, his early interaction with law enforcement had been uniformly grim. When he was little the cops would break up Wiffle ball games in the street and keep the bat. Later on, security guards would twist his collar or smack him when they caught him shoplifting. Still later the police were back, knocking on his parents’ door to warn them that their pride-and-joy was jail-bound. Once inside, they’d hand his nervous mother and defeated little dad some Polaroids of him smoking dope with the other losers in "), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("the Marilyn High parking lot. To this day he’d never discovered the narc, though the cop who’d come to his house, Officer Chatlak, was still on the squad at seventy-something.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("The worst part, for Manny, was that Chatlak never actually arrested him. He seemed to prefer keeping him out of jail so he could continue hassling him. Things were more touchy-feely in the late seventies. The public hadn’t yet developed a taste for sending boys with no armpit hair to San Quentin.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After the dozenth time Officer Chatlak took it upon himself to tell Manny’s father, man-to-man, that his only son had the makings of a “drug-addled degenerate,” the old mill-hunk showed some tough love and threw him out of the house. He was seventeen, and thrilled. It wasn’t like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nothing")]), _vm._v(" positive had ever come out of his mild police problem. He got to leave home and move in with a dope fiend named Harvey he met at the Greyhound station.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Why Manny became a cop he didn’t know—or maybe he did and didn’t want to think about it. Near as he could figure, on those rare occasions when he bothered to try, it broke down to two possibilities, equally pathetic. First, being a policeman gave him a reason to feel as badly about himself as he tended to feel anyway. At twenty-two, and coming off his season on heroin, happiness was not part of the package. Being a junkie, when you broke it down, was nothing more than a crazed day job. (Though, oddly, in that capacity, the police never seemed to hassle him at all. He became a daily shooter, thanks to his bus station roomie, and never once got so much as a parking ticket.) On some level, he believed, he needed a life that offered as much borderline insanity as the one he’d left behind….")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The second possibility was more cut and dry. Excluding food service, being a cop was the one job you could get without a college education that did not involve heavy lifting. The last thing he wanted was to join his father at J & L. But even if he’d been dying to spend his days breathing fumes from a blast furnace, the steel mills were expiring faster than World War Two vets with emphysema and Pall Mall habits.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The academy was no picnic, and most of the recruits were assholes. But the brass were overjoyed to get a rookie whose test scores qualified him for more than reminding folks that, for fifty cents more, they could get a medium Coke and free refill with their cheeseburger.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Ruby, you’re dozing again,” an old cop named Merch, Manny’s ex-partner, barked from his desk by the candy machine. The candy desk was a coveted slot at the station, since whoever got it could just lean over, bang on the sweet spot by the machine’s change dispenser, and knock out a free candy bar whenever he wanted. You never knew what you were going to get, but still….")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You’re dozing,” Merch repeated, unpeeling a fresh Fifth Avenue. Since sliding onto desk duty, he’d packed on an easy fifty pounds. “I’m trying to tell you you’re supposed to go to Carmichael Street. Guy splarked on his kitchen floor. Name’s Podolsky. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marvin")]), _vm._v(". They said he was all foamed up. Could be rabies.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Manny hated being called Ruby, but didn’t mention it since Merch, and everybody else, knew it already. Instead, he replied mildly to the overweight quill-driver. “If it’s rabies, that’s Animal Rescue. We don’t do dog calls.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Hardy-har,” said Merch. “I wrote down the address.”")])])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page19"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-508c49f3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plainclothesnaked_ch02.vue
// module id = 78
// module chunks = 0